import { render, staticRenderFns } from "./EditKostenersatz.vue?vue&type=template&id=bbcb6138&scoped=true"
import script from "./EditKostenersatz.vue?vue&type=script&lang=ts"
export * from "./EditKostenersatz.vue?vue&type=script&lang=ts"
import style0 from "./EditKostenersatz.vue?vue&type=style&index=0&id=bbcb6138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcb6138",
  null
  
)

export default component.exports